import { Link } from "react-router-dom";
function Footer() {
  return (
    <footer className="container py-5">
      <div className="row">
        <div className="col-12 col-md">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            className="d-block mb-2"
            role="img"
            viewBox="0 0 24 24"
            focusable="false"
          >
            <title>Product</title>
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M14.31 8l5.74 9.94M9.69 8h11.48M7.38 12l5.74-9.94M9.69 16L3.95 6.06M14.31 16H2.83m13.79-4l-5.74 9.94"></path>
          </svg>
          <small className="d-block mb-3 text-muted">© 2022-2023</small>
        </div>
        <div className="col-6 col-md">
          <h5>Features</h5>
          <ul className="list-unstyled text-small">
            <li>
              <Link className="text-muted" to="/products">
                Products
              </Link>
            </li>
            <li>
              <Link className="text-muted" to="/products">
                Men's fashion
              </Link>
            </li>
            <li>
              <Link className="text-muted" to="/products">
                Woomens Section
              </Link>
            </li>
            <li>
              <Link className="text-muted" to="/products">
                Jackets
              </Link>
            </li>
            <li>
              <Link className="text-muted" to="/products">
                Jeans
              </Link>
            </li>
            <li>
              <Link className="text-muted" to="/products">
                Shirts
              </Link>
            </li>
          </ul>
        </div>
        <div className="col-6 col-md">
          <h5>Pages</h5>
          <ul className="list-unstyled text-small">
            <li>
              <Link className="text-muted" to="/about">
                About us
              </Link>
            </li>
            <li>
              <Link className="text-muted" to="/contact">
                Contact us
              </Link>
            </li>
            <li>
              <Link className="text-muted" to="/">
                Home
              </Link>
            </li>
            <li>
              <Link className="text-muted" to="/products">
                Products
              </Link>
            </li>
          </ul>
        </div>
        <div className="col-6 col-md">
          <h5>Resources</h5>
          <ul className="list-unstyled text-small">
            <li>
              <a className="text-muted" href="/">
                Business
              </a>
            </li>
            <li>
              <a className="text-muted" href="/">
                Education
              </a>
            </li>
            <li>
              <a className="text-muted" href="/">
                Government
              </a>
            </li>
            <li>
              <a className="text-muted" href="/">
                Gaming
              </a>
            </li>
          </ul>
        </div>
        <div className="col-6 col-md">
          <h5>About</h5>
          <ul className="list-unstyled text-small">
            <li>
              <a className="text-muted" href="/">
                Team
              </a>
            </li>
            <li>
              <a className="text-muted" href="/">
                Locations
              </a>
            </li>
            <li>
              <a className="text-muted" href="/">
                Privacy
              </a>
            </li>
            <li>
              <a className="text-muted" href="/">
                Terms
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
export default Footer;
